import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

/**
 * The walk card's contents. Self-contained rather than relying on `.map-location-tooltip*` rules declared
 * by whichever screen mounts the map — both the passenger form and the passengers map had their own copy of
 * the same block, and a third consumer would have needed a third.
 */
export const MapLibreWalkingRouteTooltipStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "maplibre-walking-route-tooltip",
  },
)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  .map-location-tooltip-content {
    display: flex;
    flex-direction: column;
  }

  .map-location-tooltip-bold {
    font-weight: bold;
  }

  .map-location-tooltip-distance {
    font-size: 12px;
    color: ${rydeColors.black};
  }

  .map-location-tooltip-duration {
    display: flex;
    font-size: 12px;
    color: ${rydeColors.midGrey};
    gap: 4px;
  }
`;
